{
  "name": "wongpanit-cms",
  "version": "0.0.1",
  "scripts": {
    "ng": "ng",
    "start": "pnpm run start:dev",
    "start:dev": "ng serve --configuration dev --port 4200",
    "start:uat": "ng serve --configuration uat --port 4201",
    "start:prod": "ng serve --configuration prod --port 4202",
    "build:dev": "ng build --configuration dev",
    "build:uat": "ng build --configuration uat",
    "build:prod": "ng build --configuration prod",
    "watch:dev": "ng build --watch --configuration dev",
    "watch:uat": "ng build --watch --configuration uat",
    "watch:prod": "ng build --watch --configuration prod",
    "test": "ng test",
    "install:lib": "pnpm add ./pn-core-code-1.2.12.tgz"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.13",
    "@angular/common": "^18.2.13",
    "@angular/compiler": "^18.2.13",
    "@angular/core": "^18.2.13",
    "@angular/forms": "^18.2.13",
    "@angular/platform-browser": "^18.2.13",
    "@angular/platform-browser-dynamic": "^18.2.13",
    "@angular/router": "^18.2.13",
    "@gilsdav/ngx-translate-router": "^7.2.1",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@primeng/themes": "^18.0.0",
    "chart.js": "^4.4.9",
    "chartjs-adapter-date-fns": "^3.0.0",
    "date-fns": "^4.1.0",
    "dayjs": "^1.11.13",
    "gulp": "^5.0.0",
    "gulp-replace": "^1.1.4",
    "lodash": "^4.17.21",
    "ngx-translate-multi-http-loader": "^19.0.1",
    "pn-core-code": "file:pn-core-code-1.2.12.tgz",
    "primeflex": "^3.3.1",
    "primeicons": "^7.0.0",
    "primeng": "^18.0.0",
    "rxjs": "~7.8.1",
    "tailwindcss-primeui": "^0.3.4",
    "tslib": "^2.8.1",
    "uuid": "^11.0.3",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.12",
    "@angular/cli": "^18.2.12",
    "@angular/compiler-cli": "^18.2.13",
    "@types/jasmine": "~5.1.5",
    "@types/lodash": "^4.17.13",
    "@types/uuid": "^10.0.0",
    "autoprefixer": "^10.4.20",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ng-packagr": "^18.2.1",
    "postcss": "^8.4.49",
    "prettier": "^3.4.2",
    "prettier-plugin-tailwindcss": "^0.6.9",
    "tailwindcss": "^3.4.16",
    "typescript": "~5.5.4"
  }
}
